// ============================================================
// หน้า Profile — จัดการโปรไฟล์โครงการ
// ------------------------------------------------------------
// แก้ข้อมูลโครงการที่กำลังใช้งานอยู่ (ชื่อ ที่อยู่ เบอร์โทร เลขผู้เสียภาษี รูป)
// "รูปหัวกระดาษ" คือรูปที่ไปโผล่บนหัวเอกสารใบเสร็จ/ใบแจ้งหนี้
//
// เห็นเฉพาะเจ้าของระบบ (กำหนดที่เมนูใน Navbar)
// ปุ่มบันทึกใช้สิทธิ์ "สร้าง" ของเมนูจัดการอัตราค่าน้ำ (ตามของเดิม)
// ============================================================

import React, { Component } from "react";
import Resizer from "react-image-file-resizer";
import Select from "react-select";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import province from "../../shared/config/province.json";
import { tokens, select_style, GET, PUT, validate, getStorage, success_url, loading, permission, ICON } from "../../shared/index.js";

const perm = permission("manage-water");

// รายการ ตำบล/อำเภอ/จังหวัด สำหรับ dropdown
const ARRAY_ADDRESS = province.map((e) => ({ value: e.ID, label: `${e.SUB_DISTRICT}, ${e.DISTRICT}, ${e.ROVINCE}`, zipcode: e.ZIPCODE }));

// เตรียมค่า src ให้ <img> — รูปที่เก็บไว้มีได้ 3 แบบ: url, data URI, base64 เปล่า
// NOTE url ที่ backend ส่งมาบางครั้งมี "//media" ต้องแก้เป็น "/media" ไม่งั้นโหลดรูปไม่ขึ้น
const imageSrc = (value) => {
  if (value.includes("http")) return value.replace("//media", "/media");
  if (value.includes(";base64,")) return value;
  return `data:image/png;base64,${value}`;
};

export default class Profile extends Component {
  state = {
    project_id: getStorage("project_id"),
    project_name: "",
    project_number: "",
    address_detail: "",
    address_id: null,
    post_code: "",
    phone_number: "",
    tax_number: "",
    picture: "", // รูปโครงการ
    picture_paper: "", // รูปหัวกระดาษเอกสาร
  };

  componentDidMount() {
    loading(false);
    this.GetProject();
  }

  // แปลงรูปจาก url เป็น base64 (ให้พรีวิวและส่งกลับ backend ได้)
  toDataUrl = async (url) => {
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      return await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]);
        reader.readAsDataURL(blob);
      });
    } catch {
      return global.logo;
    }
  };

  GetProject = async () => {
    loading(true);
    const result = await GET(tokens, `v1/TH/project-manage/detail/${this.state.project_id}`, null);
    if (result?.status) {
      const d = result.data.data;
      this.setState({
        project_name: d.project_name || "",
        project_number: d.project_number || "",
        address_detail: d.address_detail || "",
        address_id: d.address_id ? ARRAY_ADDRESS.find((e) => String(e.value) === String(d.address_id)) : null,
        post_code: d.address_obj?.ZIPCODE || "",
        phone_number: d.phone_number || "",
        tax_number: d.tax_number || "",
        picture: d.picture ? await this.toDataUrl(d.picture) : "",
        picture_paper: d.picture_paper ? await this.toDataUrl(d.picture_paper) : "",
      });
      // เก็บรูปหัวกระดาษไว้ให้หน้าพิมพ์เอกสารใช้
      localStorage.setItem("picture_paper", d.picture_paper);
    }
    loading(false);
  };

  Update = async () => {
    if (validate(this.state, ["project_number", "project_name", "address_detail", "address_id", "post_code", "phone_number", "tax_number"])) return;

    loading(true);
    const { project_id, project_name, project_number, address_id, address_detail, phone_number, tax_number, picture, picture_paper } = this.state;
    const result = await PUT(tokens, "v1/TH/project-manage/update", {
      project_id,
      project_name,
      project_number,
      address_id: address_id?.value || "",
      address_detail,
      phone_number,
      tax_number,
      picture,
      picture_paper,
    });
    if (result?.status) success_url("/profile");
    loading(false);
  };

  // เลือกรูป — ย่อเป็น 128x128 แล้วเก็บเป็น base64
  handlePhoto = (e, field) => {
    if (!e.target.files[0]) return;
    Resizer.imageFileResizer(e.target.files[0], 128, 128, "JPG", 100, 0, (uri) => this.setState({ [field]: uri.split(",")[1] }), "base64");
  };

  // ช่องกรอกข้อความ
  //   readOnly = true อ่านอย่างเดียว | numeric = true รับเฉพาะตัวเลข
  renderField = (label, field, type = "text", maxLength = null, readOnly = false, numeric = false) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140 mb-0">{label}:</label>
      <input
        className="form-control border-0 bg-contain"
        type={type}
        maxLength={maxLength}
        placeholder="กรอกข้อมูล"
        value={this.state[field]}
        readOnly={readOnly}
        onChange={(e) => this.setState({ [field]: numeric ? e.target.value.replace(/\D/g, "") : e.target.value })}
      />
    </div>
  );

  // ช่องเลือกรูป — ยังไม่มีรูปแสดงปุ่มนำเข้า, มีแล้วแสดงพรีวิว + ปุ่มกากบาทลบ
  renderImageField = (label, field) => {
    const value = this.state[field];
    return (
      <div className="w-100 d-flex align-items-center mb-3">
        <label className="wpx-140 mb-0">{label}:</label>
        {!value ? (
          <button className="btn btn-outline-primary w-100" onClick={() => document.getElementById(field).click()}>
            นำเข้าไฟล์
          </button>
        ) : (
          <div className="card p-3 align-items-center text-center w-100 position-relative">
            <img alt="โครงการ" src={imageSrc(value)} className="wpx-200 img-responsive" />
            <div
              className="wpx-32 hpx-32 rounded-circle bg-danger text-white icon text-24 d-flex justify-content-center align-items-center position-absolute pointer"
              style={{ right: -6, top: -6 }}
              onClick={() => this.setState({ [field]: "" })}
            >
              {ICON.close}
            </div>
          </div>
        )}
        <input className="d-none" id={field} type="file" accept="image/*" onChange={(e) => this.handlePhoto(e, field)} />
      </div>
    );
  };

  render() {
    const s = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="จัดการอัตราค่าน้ำ" />
        <div className="body">
          <div className="px-3 pt-3 pb-5">
            <div className="col-12 col-sm-10 col-md-8 col-lg-10 col-xl-8 col-xxl-5 mx-auto">
              <div className="card border-0 bg-gray p-3 mb-3">
                <h4 className="mb-0">
                  <b>โปรไฟล์</b>
                </h4>
              </div>

              <div className="card border-0 px-3 pt-3 mb-3">
                {this.renderField("รหัสโครงการ", "project_number", "text", 4, false, true)}
                {this.renderField("ชื่อโครงการ", "project_name")}

                <div className="w-100 d-flex mb-3">
                  <label className="wpx-140 mb-0">ที่อยู่:</label>
                  <textarea className="form-control border-0 bg-contain" placeholder="กรอกข้อมูล" value={s.address_detail} onChange={(e) => this.setState({ address_detail: e.target.value })} />
                </div>

                {/* เลือกตำบล/อำเภอ/จังหวัด แล้วเติมรหัสไปรษณีย์ให้อัตโนมัติ */}
                <div className="w-100 d-flex align-items-center mb-3">
                  <label className="wpx-140 mb-0">ตำบล อำเภอ จังหวัด:</label>
                  <Select
                    className="form-control border-0 bg-contain select-search"
                    styles={select_style}
                    options={ARRAY_ADDRESS}
                    placeholder="-- เลือก --"
                    value={s.address_id}
                    isClearable
                    onChange={(e) => this.setState({ address_id: e, post_code: e ? e.zipcode : "" })}
                  />
                </div>

                {this.renderField("รหัสไปรษณีย์", "post_code", "text", null, true)}
                {this.renderField("เบอร์โทร", "phone_number", "tel", 10, false, true)}
                {this.renderField("เลขผู้เสียภาษี", "tax_number", "text", 13, false, true)}
                {this.renderImageField("รูปโครงการ", "picture")}
                {this.renderImageField("รูปหัวกระดาษ", "picture_paper")}
              </div>

              {perm.create && (
                <div className="row mx-0">
                  <div className="ml-auto col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
                    <button className="btn btn-outline-primary w-100" onClick={() => window.location.reload()}>
                      ยกเลิก
                    </button>
                  </div>
                  <div className="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
                    <button className="btn btn-primary w-100" onClick={this.Update}>
                      บันทึก
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
